import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, Subscription, forkJoin, fromEvent } from 'rxjs';
import { startWith, takeUntil } from 'rxjs';
import { AppLoginService } from '../app-login.service';
import { RegistrationService } from '@app/registration/registration.service';
import { VALIDATORS } from '@app/@core/entities/validators.constant';
import { HttpService } from '@app/@core/services/http.service';
import { TOAST_CODES } from '@app/@core/entities/notification-codes.constant';

@Component({
  standalone: false,
  selector: 'app-forgot-password-email',
  templateUrl: './forgot-password-email.component.html',
  styleUrls: ['./forgot-password-email.component.scss']
})
export class ForgotPasswordEmailComponent implements OnInit, OnDestroy {

  findAccountForm: FormGroup;
  isSubmitted = false;
  emailSent = false;
  isMobile = false;
  logoPath = 'assets/images/edu-logo.svg';
  resizeObservable$: Subscription | undefined;
  isButtonDisabled = true;
  toastMessageArray:any = []
  toastMessage:string | null = null
  showToastDiv:boolean = false
  email: string = '';
  toastType:boolean
  private destroy$ = new Subject<void>()

    constructor(private readonly fb: FormBuilder,
       private readonly router: Router, 
       private readonly appLoginService: AppLoginService,
     private readonly registrationService: RegistrationService,
    private route: ActivatedRoute , private httpService:HttpService) {}

    ngOnInit(): void {
    this.initForm();
    this.setupResponsiveImage();
  }
 
  ngOnDestroy(): void {
    if (this.resizeObservable$) {
      this.resizeObservable$.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete()
  }

  async getToastMessage(){
      const storedToastMessage = localStorage.getItem('toastMessages')
      if(storedToastMessage) {
        this.toastMessageArray = JSON.parse(storedToastMessage)
        return
      }
      forkJoin([
        this.httpService.get('/domain/lookup?requestType=TOAST MESSAGES'),
        this.httpService.get('/domain/lookup?requestType=GENERIC MESSAGES'),
      ])
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next:(items : any)=>{
          this.toastMessageArray = items[0]
        }
      })
    }
 
  setupResponsiveImage(): void {
    this.resizeObservable$ = fromEvent(window, 'resize').pipe(startWith({} as Event))
      .subscribe(() => {
        this.isMobile = window.innerWidth < 768;
        this.updateLogoPath();
      });
   
   
    this.isMobile = window.innerWidth < 768;
    this.updateLogoPath();
  }
 
  updateLogoPath(): void {
    this.logoPath = this.isMobile
      ? 'assets/images/cardy-ai/mobile-logo.svg'
      : 'assets/images/edu-logo.svg';
  }
 
  initForm(): void {
    this.findAccountForm = this.fb.group({
      email: ['', [Validators.required, Validators.email, Validators.pattern(VALIDATORS.MAX_EMAIL_CHAREACTER_ALLOWED)]]
    });
 
    // Monitor email field changes to enable/disable button
    this.findAccountForm.get('email')?.valueChanges.subscribe(() => {
      this.isButtonDisabled = !this.findAccountForm.get('email')?.valid;
    });
  }
 
  get formControls() {
    return this.findAccountForm.controls;
  }
 
  onSubmit(): void {
    this.isSubmitted = true;
    if (this.findAccountForm.valid) {
       this.isButtonDisabled = true; // Disable button on submission
       this.emailSent = true;
       if (this.emailSent === true ) {
          // Phone exists, proceed
          //show toast message
          const toast = this.toastMessageArray?.data?.find((t:any) => t.key === TOAST_CODES.PHONE_EXIST );
          const message = (toast?.value)
          this.showToast(message , this.emailSent)
       setTimeout(() => {
        this.emailSending();
       }, 3000);
       } else{
        // Phone does not exist, show error
          const toast = this.toastMessageArray?.data?.find((t:any) => t.key === TOAST_CODES.PHONE_NOT_EXIST);
          const message = (toast?.value || 'T0046: Email not found. Make sure your Email is correct.')
          this.showToast(message , this.emailSent)
          this.isButtonDisabled = false;
       }
    }
  }
  emailSending(): void {
    const request = {
      email: this.findAccountForm.get('email')?.value,
      // front_end_domain: environment.frontEndDomain
    };
    const email = this.findAccountForm.get('email').value;

     this.registrationService.sendPrimaryEmailOtp(request).subscribe({
      next: response => {
        this.router.navigate(['/verify-forgot-password'], { queryParams: { from: 'forgot-password-email', email } });
        
      },
      error: error => {
        console.error('Error sending recovery email verification:', error);

      }
    });
  }

  showToast(message:string , type:boolean){
  this.toastMessage = message
  this.toastType = type
  this.showToastDiv = true

  setTimeout(() => {
    this.showToastDiv = false
  }, 3000);
}
  cancel(): void {
       this.router.navigate(['app-login/find-account']);
     }

}
